import styled from 'styled-components'

const StyledText = styled.p`
  font-size: ${props => props.theme.fontSizes.sm};
  color:  ${props => props.color ? props.color : props.theme.colors.white};
  margin: ${props => props.margin};
`

export {StyledText}